export default {
  title: 'Select Production Batch',
};
